import { defineNuxtPlugin, useRuntimeConfig } from "#app";
import "vue";
import { c as createYmapsOptions, i as initYmaps } from "../vue-yandex-maps-CV74ncB3.js";
const nuxt3Plugin = defineNuxtPlugin({
  async setup() {
    const settings = useRuntimeConfig().public.yandexMaps;
    createYmapsOptions(settings);
    if (import.meta.client && settings.initializeOn === "onPluginInit") {
      initYmaps().catch(console.error);
    }
  }
});
export {
  nuxt3Plugin as default
};
